import * as React from 'react';

import {SelectTheme} from 'common/components/select/constants';
import {SelectReact} from 'common/components/select';
import {isCohortSegment, SegmentValue} from 'common/query-builder/query-block/segment-menu/types';
import {Segmentation} from 'common/types/reports/query';
import {getLabelForPropertyType} from 'common/report/util/properties';
import {getPropertyType, setPropertyType} from 'common/query-builder/query-entry-section/row-types/row-util';
import {PropertyType} from 'common/report/constants';
import {ButtonSize} from 'common/components/button/constants';

import {ControlBarAction, ControlBarActionItems} from '../constants';
import {isMultiAttributionSegmentation} from '../row-types/behavior/utils';

/**
 * Renders typecasting controls for a given Segmentation entry on filters or breakdowns
 */
export function TypecastSubitem(props: {
  value: SegmentValue;
  onTypeChange: (newValue: SegmentValue) => void;
  forFilter?: boolean;
  disabledTypes?: PropertyType[];
}) {
  if (!props.value || isCohortSegment(props.value) || isMultiAttributionSegmentation(props.value)) {
    return null;
  }

  const segmentation = props.value as Segmentation;
  const fullType = getPropertyType(segmentation);

  return (
    <>
      {fullType.type && fullType.type !== segmentation.propertyDefaultType && (
        <div className='subitem-text'>
          <SelectReact
            className='subitem-select'
            theme={SelectTheme.QbSubitem}
            size={ButtonSize.Small}
            menuWidth={null}
            neverShowCaret
            label={`Data type changed to **${fullType.isList ? `List of ` : ``}${getLabelForPropertyType(
              fullType.type,
            )}**`}
            elref='typecastSubitem'
            sections={
              ControlBarActionItems[ControlBarAction.Typecast](fullType, {disabledTypes: props.disabledTypes})
                .subSections
            }
            onChange={(ev: CustomEvent) => {
              props.onTypeChange(setPropertyType(segmentation, ev.detail.item.value.toType, props.forFilter));
            }}
          />
        </div>
      )}
    </>
  );
}
